import styled from 'styled-components';
import StyledLink from '../../../../shared/components/global/StyledLink';
import { Discipline } from '../../model/talentpool/discipline';

const SearchTagsCentered = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  position: relative;
`;

const SearchTag = styled.p`
    border: 1px solid ${(props) => props.theme.colors.fontBlack};
    border-radius: 40px;
    display: inline-block;
    font-size: 14px;
    font-weight: 700;
    line-height: 16px;
    margin-bottom: 8px;
    margin-right: 8px;
    margin-top: 0;
    padding: 8px 16px;
    user-select: none;
    color : ${(props) => props.theme.colors.fontBlack};

    &:hover {
        border: 1px solid ${(props) => props.theme.colors.secondary};
        background-color: ${(props) => props.theme.colors.buttonSubtle};
        transform: scale3d(1.02,1.02,1.02);
    }
`;

export default function JobsCommonSearches() {

    const tags = Object.values(Discipline);

    return (
        <div>
            <h1>Beliebte Suchanfragen</h1>
            <SearchTagsCentered>
                {tags.map((tag, index) =>
                    <StyledLink key={tag + index} href={`/jobs/search?what=${tag}`}>
                        <SearchTag>{tag}</SearchTag>
                    </StyledLink>
                )}
            </SearchTagsCentered>
        </div>
    )
}
